import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  key = 'notification';

  constructor(public hs: HttpService) {}

  async get_list(filters: any = {}) {
    try {
      return await this.hs.get(`/${this.key}/get-notification-list`, filters);
    } catch (error: any) {
      throw error;
    }
  }

  async get_unread_count() {
    try {
      return await this.hs.get(`/${this.key}/get-unread-count`, {});
    } catch (error: any) {
      throw error;
    }
  }

  async mark_as_read(ids: number[]) {
    try {
      return await this.hs.post(`/${this.key}/mark-as-read`, {}, { ids });
    } catch (error: any) {
      throw error;
    }
  }

  async mark_all_read() {
    try {
      return await this.hs.post(`/${this.key}/mark-as-read`, {}, { mark_all: true });
    } catch (error: any) {
      throw error;
    }
  }
}
